import P from './P';
import H1 from './H1';
import H2 from './H2';
import H3 from './H3';
import H4 from './H4';
import Span from './Span';
import Label from './Label';
import LI from './LI';
import Link from './Link';

export { H1, H2, H3, H4, P, Span, Label, LI, Link };



// WEBPACK FOOTER //
// ./src/typography/index.ts